import { useQuery } from '@tanstack/react-query';
import { FC, PropsWithChildren, useMemo } from 'react';
import { getConfigQueryOptions } from '../../queries/get-config';
import { useAuthenticationContext } from '../AuthenticationContext/useAuthenticationContext';
import { useHealthCenterContext } from '../HealthCenterContext';
import { ConfigContext } from './ConfigContext';

export const ConfigProvider: FC<PropsWithChildren> = ({ children }: PropsWithChildren) => {
  const { user, healthCenter, loading: authLoading } = useAuthenticationContext();
  const { healthCenterConfig } = useHealthCenterContext();

  const healthCenterId = useMemo(() => {
    if (user?.role === 'PORTER' && healthCenterConfig?.id) {
      return `${healthCenterConfig.id}`;
    }
    if (user?.role === 'BED_MANAGER' && healthCenter?.id) {
      return `${healthCenter.id}`;
    }
    return undefined;
  }, [user?.role, healthCenter?.id, healthCenterConfig?.id]);

  const { data: config, isLoading } = useQuery({
    ...getConfigQueryOptions(healthCenterId!),
    enabled: !!healthCenterId && !authLoading,
  });

  return (
    <ConfigContext.Provider
      value={{
        config,
        isLoading,
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
};
